import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  withHandlers,
  lifecycle
} from 'recompose';
import { withRouter } from 'react-router';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import ReactSelectMaterialUi from 'react-select-material-ui';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import MenuItem from '@material-ui/core/MenuItem';
import Divider from '@material-ui/core/Divider';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import ConfirmButton from '../../components/atoms/ConfirmButton';
import PublicHeader from '../../components/PublicHeader';
import PublicFooter from '../../components/PublicFooter';
import GroupAddConfirm from '../organisms/GroupAddConfirm';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import { signUp, confirmSignUp } from '../../auth/Auth';
import RequiredButton from '../../components/atoms/RequiredButton';
import AnyButton from '../../components/atoms/AnyButton';
import ValidationText from '../../components/atoms/ValidationText';
import SendCodeButton from '../../components/atoms/SendCodeButton';
import CheckOkButton from '../../components/atoms/CheckOkButton';
import FileUpload from '../../components/molecules/FileUpload';
import { getOptionCities } from '../../actions/Cities';
import { getZipCode } from '../../actions/Shop';

const styles = {
  root: {
    backgroundColor: '#ffffff',
    flexGrow: 1,
    width: '100%'
  },
  pageTitileDiv: {
    padding: '2px 0px 10px 20px',
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  description: {
    color: '#707070',
    margin: '20px 0px 0px'
  },
  mainPaper: {
    position: 'relative',
    margin: 1,
    padding: 10
  },
  mainPaperTitleDiv: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '20px 26px 10px 26px'
  },
  addTable: {},
  subTitle: {
    margin: '20px 0px 0px',
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  tableCell90: {
    width: '90%'
  },
  tableCellBorderNone: {
    borderBottom: 'none'
  },
  depositManageDiv: {
    paddingTop: '1.5rem'
  },
  textField: {
    padding: '0px 5px 0px 5px'
  },
  discription: {
    fontSize: '0.875rem'
  },
  caution: {
    color: 'red',
    fontWeight: 'bold',
    textDecoration: 'underline'
  },
  greyText: {
    color: '#BABABA'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      cities: state.cities.listCities,
      prefectures: state.commons.prefectures
    }),
    dispatch => ({
      actions: bindActionCreators({ getOptionCities, getZipCode }, dispatch)
    })
  ),
  setPropTypes(propTypes),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('groupName', 'setGroupName', ''),
  withState('groupNameError', 'setGroupNameError', ''),
  withState('zipCode', 'setZipCode', ''),
  withState('zipCodeError', 'setZipCodeError', ''),
  withState('prefectureCode', 'setPrefectureCode', 0),
  withState('prefecturesError', 'setPrefecturesError', ''),
  withState('city', 'setCity', ''),
  withState('cityError', 'setCityError', ''),
  withState('cityIdError', 'setCityIdError', ''),
  withState('cityId', 'setCityId', ''),
  // withState('cityName', 'setCityName', ''),
  // withState('cityNameError', 'setCityNameError', ''),
  withState('address', 'setAddress', ''),
  withState('addressError', 'setAddressError', ''),
  withState('building', 'setBuilding', ''),
  withState('phone', 'setPhone', ''),
  withState('phoneError', 'setPhoneError', ''),
  withState('fax', 'setFax', ''),
  withState('faxError', 'setFaxError', ''),
  withState('groupContactName', 'setGroupContactName', ''),
  withState('groupContactNameError', 'setGroupContactNameError', ''),
  withState('department', 'setDepartment', ''),
  withState('departmentError', 'setDepartmentError', ''),
  withState('directPhone', 'setDirectPhone', ''),
  withState('directPhoneError', 'setDirectPhoneError', ''),
  withState('groupType', 'setGroupType', 'CHAIN_SHOP'),
  withState('groupTypeStr', 'setGroupTypeStr', 'チェーン店'),
  withState('depositManage', 'setDepositManage', 'NOT_MANAGE'),
  withState(
    'depositManageStr',
    'setDepositManageStr',
    'グループでは入金管理を登録しない'
  ),
  withState('bankName', 'setBankName', ''),
  withState('bankNameError', 'setBankNameError', ''),
  withState('bankBranchName', 'setBankBranchName', ''),
  withState('bankBranchNameError', 'setBankBranchNameError', ''),
  withState('bankAccountType', 'setBankAccountType', 'SAVINGS'),
  withState('bankAccountTypeStr', 'setBankAccountTypeStr', '普通預金'),
  withState('bankAccountNumber', 'setBankAccountNumber', ''),
  withState('bankAccountNumberError', 'setBankAccountNumberError', ''),
  withState('bankAccountHolder', 'setBankAccountHolder', ''),
  withState('bankAccountHolderError', 'setBankAccountHolderError', ''),
  // withState('registerReason', 'setRegisterReason', ''),
  // withState('registerReasonError', 'setRegisterReasonError', ''),
  withState('linkingShopMessage', 'setLinkingShopMessage', ''),
  withState('linkingShopMessageError', 'setLinkingShopMessageError', ''),
  withState('cognitoUserId', 'setCognitoUserId', ''),
  withState('email', 'setEmail', ''),
  withState('emailError', 'setEmailError', ''),
  withState('password', 'setPassword', ''),
  withState('passwordError', 'setPasswordError', ''),
  withState('confirmPassword', 'setConfirmPassword', ''),
  withState('confirmPasswordError', 'setConfirmPasswordError', ''),
  withState('emailAuthCode', 'setEmailAuthCode', ''),
  withState('emailAuthCodeError', 'setEmailAuthCodeError', ''),
  withState('emailAuthCodeChecked', 'setEmailAuthCodeChecked', false),
  withState('consent', 'setConsent', false),
  withState('openGroupAddConfirm', 'updateOpenGroupAddConfirm', false),
  withState('images', 'setImages', null),
  withState('image1', 'setImage1', null),
  withState('previewImage1', 'setPreviewImage1', null),
  withState('image2', 'setImage2', null),
  withState('previewImage2', 'setPreviewImage2', null),
  withState('image3', 'setImage3', null),
  withState('previewImage3', 'setPreviewImage3', null),
  withState('image4', 'setImage4', null),
  withState('previewImage4', 'setPreviewImage4', null),
  withState('image5', 'setImage5', null),
  withState('previewImage5', 'setPreviewImage5', null),
  withState('description', 'setDescription', ''),
  withState('website', 'setWebsite', ''),
  withState('websiteError', 'setWebsiteError', ''),
  withState('cashAllowed', 'setCashAllowed', 0),
  withState('allowMenuPriceShashoku', 'setAllowMenuPriceShashoku', 0),
  withHandlers({
    handleRedirect: props => path => {
      props.history.push(path);
    }
  }),
  lifecycle({
    componentDidMount() {
      this.props.actions.getOptionCities();
    }
  })
);

const Main = enhance(
  ({
    classes, // actions,
    openGroupAddConfirm,
    registerAction,
    loading,
    updateLoading,
    openProgress,
    updateOpenProgress,
    resultMessage,
    setResultMessage,
    groupName,
    setGroupName,
    zipCode,
    setZipCode,
    prefectures,
    prefectureCode,
    setPrefectureCode,
    cities,
    city,
    setCity,
    cityId,
    // cityName,
    // setCityName,
    setCityId,
    address,
    setAddress,
    building,
    setBuilding,
    phone,
    setPhone,
    fax,
    setFax,
    groupContactName,
    setGroupContactName,
    department,
    setDepartment,
    directPhone,
    setDirectPhone,
    groupType,
    setGroupType,
    groupTypeStr,
    setGroupTypeStr,
    depositManage,
    setDepositManage,
    depositManageStr,
    setDepositManageStr,
    bankName,
    setBankName,
    bankBranchName,
    setBankBranchName,
    bankAccountType,
    setBankAccountType,
    bankAccountTypeStr,
    setBankAccountTypeStr,
    bankAccountNumber,
    setBankAccountNumber,
    bankAccountHolder,
    setBankAccountHolder,
    // registerReason,
    // setRegisterReason,
    // registerReasonError,
    // setRegisterReasonError,
    linkingShopMessage,
    setLinkingShopMessage,
    linkingShopMessageError,
    setLinkingShopMessageError,
    email,
    setEmail,
    password,
    setPassword,
    confirmPassword,
    setConfirmPassword,
    emailAuthCode,
    setEmailAuthCode,
    updateOpenGroupAdd,
    updateOpenGroupAddConfirm,
    groupNameError,
    setGroupNameError,
    zipCodeError,
    setZipCodeError,
    prefecturesError,
    setPrefecturesError,
    cityIdError,
    setCityIdError,
    // cityError,
    // setCityError,
    addressError,
    setAddressError,
    phoneError,
    setPhoneError,
    faxError,
    setFaxError,
    groupContactNameError,
    setGroupContactNameError,
    departmentError,
    setDepartmentError,
    directPhoneError,
    setDirectPhoneError,
    bankNameError,
    setBankNameError,
    bankBranchNameError,
    setBankBranchNameError,
    bankAccountNumberError,
    setBankAccountNumberError,
    bankAccountHolderError,
    setBankAccountHolderError,
    cognitoUserId,
    setCognitoUserId,
    emailError,
    setEmailError,
    passwordError,
    setPasswordError,
    confirmPasswordError,
    setConfirmPasswordError,
    emailAuthCodeError,
    setEmailAuthCodeError,
    emailAuthCodeChecked,
    setEmailAuthCodeChecked,
    consent,
    setConsent,
    handleRedirect,
    images,
    setImages,
    image1,
    setImage1,
    previewImage1,
    setPreviewImage1,
    image2,
    setImage2,
    previewImage2,
    setPreviewImage2,
    image3,
    setImage3,
    previewImage3,
    setPreviewImage3,
    image4,
    setImage4,
    previewImage4,
    setPreviewImage4,
    image5,
    setImage5,
    previewImage5,
    setPreviewImage5,
    description,
    setDescription,
    website,
    setWebsite,
    websiteError,
    setWebsiteError,
    cashAllowed,
    setCashAllowed,
    allowMenuPriceShashoku,
    setAllowMenuPriceShashoku
  }) => {
    const addConfirm = {
      groupName,
      zipCode,
      prefectureCode,
      city,
      // cityName,
      address,
      building,
      phone,
      fax,
      groupContactName,
      department,
      directPhone,
      groupTypeStr,
      depositManageStr,
      bankName,
      bankBranchName,
      bankAccountTypeStr,
      bankAccountNumber,
      bankAccountHolder,
      // registerReason,
      linkingShopMessage,
      email,
      previewImage1,
      previewImage2,
      previewImage3,
      previewImage4,
      previewImage5,
      description,
      website,
      cashAllowed,
      allowMenuPriceShashoku
    };
    const bankAccount = {
      bankName,
      bankBranchName,
      bankAccountType,
      bankAccountNumber,
      bankAccountHolder
    };
    const addParam = {
      groupName,
      zipCode,
      prefectureCode,
      city,
      // cityName,
      cityId,
      address,
      building,
      phone,
      fax,
      groupContactName,
      department,
      directPhone,
      groupType,
      depositManage,
      bankAccount,
      // registerReason,
      linkingShopMessage,
      cognitoUserId,
      email,
      images,
      description,
      website,
      groupDetail:
        groupType !== 'OTHERS'
          ? {
              cashAllowed,
              allowMenuPriceShashoku
            }
          : undefined
    };
    const errors = {
      groupNameError,
      zipCodeError,
      prefecturesError,
      // cityError,
      cityIdError,
      addressError,
      groupContactNameError,
      departmentError,
      directPhoneError,
      phoneError,
      faxError,
      bankNameError,
      bankBranchNameError,
      bankAccountNumberError,
      bankAccountHolderError,
      // registerReasonError,
      linkingShopMessageError,
      emailError,
      passwordError,
      confirmPasswordError,
      emailAuthCodeError,
      websiteError
    };

    // const getZipCodeData = async zipcode => {
    //   await actions.getZipCode(zipcode).then(data => {
    //     setPrefectureCode(data.payload.prefectureCode);
    //     setCity(data.payload.city);
    //     setAddress(data.payload.address);
    //   });
    // };

    const checkCityName = () => {
      const chosenCityNameList = [];
      cities
        .filter(item => item.cityName && item.cityName === city)
        .forEach(item => {
          chosenCityNameList.push({
            label: item.cityName,
            value: String(item.cityId)
          });
        });
      if (chosenCityNameList.length > 0) {
        return Number(chosenCityNameList[0].value);
      }
      return Number(0);
    };

    useEffect(() => {
      setCityId(checkCityName());
    }, [city]);

    const validGroup = () => {
      const value = groupName.trim();
      if (value === '') {
        setGroupNameError('必須項目です。');
        return 1;
      }
      setGroupNameError('');
      setGroupName(value);
      return 0;
    };
    const validZipCode = () => {
      const value = zipCode.trim();
      if (value === '') {
        setZipCodeError('必須項目です。');
        return 1;
      }
      if (!/^\d{7}$/.test(value)) {
        setZipCodeError('0000000形式で入力してください。');
        return 1;
      }
      setZipCodeError('');
      setZipCode(value);
      // getZipCodeData(value);
      return 0;
    };
    const validZipCodeSubmit = () => {
      const value = zipCode.trim();
      if (value === '') {
        setZipCodeError('必須項目です。');
        return 1;
      }
      if (!/^\d{7}$/.test(value)) {
        setZipCodeError('0000000形式で入力してください。');
        return 1;
      }
      setZipCodeError('');
      setZipCode(value);
      return 0;
    };
    const validPrefectures = () => {
      const value = prefectureCode;
      if (value === 0) {
        setPrefecturesError('必須項目です。');
        return 1;
      }
      setPrefecturesError('');
      setPrefectureCode(value);
      return 0;
    };
    // const validCity = () => {
    //   const value = city.trim();
    //   if (value === '') {
    //     setCityError('必須項目です。');
    //     return 1;
    //   }
    //   setCityError('');
    //   setCity(value);
    //   return 0;
    // };
    const validCityId = () => {
      const value = cityId;
      if (value === 0) {
        setCityIdError('必須項目です。');
        return 1;
      }
      setCityIdError('');
      setCityId(value);
      return 0;
    };
    const setCityNameData = id => {
      cities.forEach(item => {
        if (id === item.cityId) {
          setCity(item.cityName);
        }
      });
    };
    const validAddress = () => {
      const value = address.trim();
      if (value === '') {
        setAddressError('必須項目です。');
        return 1;
      }
      setAddressError('');
      setAddress(value);
      return 0;
    };
    const validGroupContactName = () => {
      const value = groupContactName.trim();
      if (value === '') {
        setGroupContactNameError('必須項目です。');
        return 1;
      }
      setGroupContactNameError('');
      setGroupContactName(value);
      return 0;
    };
    const validDepartment = () => {
      const value = department.trim();
      if (value === '') {
        setDepartmentError('必須項目です。');
        return 1;
      }
      setDepartmentError('');
      setDepartment(value);
      return 0;
    };
    const validDirectPhone = () => {
      const value = directPhone;
      if (value === '') {
        setDirectPhoneError('必須項目です。');
        return 1;
      }
      if (!/^\d+$/.test(value)) {
        setDirectPhoneError('数字をハイフン(-)なしで入力してください。');
        return 1;
      }
      setDirectPhoneError('');
      setDirectPhone(value);
      return 0;
    };
    const validPhone = () => {
      const value = phone.trim();
      if (value === '') {
        setPhoneError('必須項目です。');
        return 1;
      }
      if (!/^\d+$/.test(value)) {
        setPhoneError('数字をハイフン(-)なしで入力してください。');
        return 1;
      }
      setPhoneError('');
      setPhone(value);
      return 0;
    };
    const validFax = () => {
      const value = fax.trim();
      if (value && !/^\d+$/.test(value)) {
        setFaxError('数字をハイフン(-)なしで入力してください。');
        return 1;
      }
      setFaxError('');
      setFax(value);
      return 0;
    };
    const validBankName = () => {
      const value = bankName.trim();
      if (depositManage === 'NONSELF' && value === '') {
        setBankNameError('必須項目です。');
        return 1;
      }
      setBankNameError('');
      setBankName(value);
      return 0;
    };
    const validBankBranchName = () => {
      const value = bankBranchName.trim();
      if (depositManage === 'NONSELF' && value === '') {
        setBankBranchNameError('必須項目です。');
        return 1;
      }
      setBankBranchNameError('');
      setBankBranchName(value);
      return 0;
    };
    const validBankAccountNumber = () => {
      const value = bankAccountNumber.trim();
      if (depositManage === 'NONSELF') {
        if (value === '') {
          setBankAccountNumberError('必須項目です。');
          return 1;
        }
        if (!/^\d{7}$/.test(value)) {
          setBankAccountNumberError('半角数字のみで7桁で入力してください。');
          return 1;
        }
      }
      setBankAccountNumberError('');
      setBankAccountNumber(value);
      return 0;
    };
    const validBankAccountHolder = () => {
      const value = bankAccountHolder.trim();
      if (depositManage === 'NONSELF') {
        if (value === '') {
          setBankAccountHolderError('必須項目です。');
          return 1;
        }
        if (
          !/^[0-9a-zA-Z!-/:-@¥[-`{-~！-／：-＠［-｀｛-～、-〜”’・ー‐−―￥ァ-ヴ\x20\u3000]+$/.test(
            value
          )
        ) {
          setBankAccountHolderError('漢字/ひらがな以外で入力してください。');
          return 1;
        }
      }
      setBankAccountHolderError('');
      setBankAccountHolder(value);
      return 0;
    };
    // const validRegisterReason = () => {
    //   const value = registerReason.trim();
    //   if (value === '') {
    //     setRegisterReasonError('必須項目です。');
    //     return 1;
    //   }
    //   setRegisterReasonError('');
    //   setRegisterReason(value);
    //   return 0;
    // };
    const validLinkingShopMessage = () => {
      const value = linkingShopMessage.trim();
      if (value.length > 1000) {
        setLinkingShopMessageError('1000桁以内ご入力お願いします。');
        return 1;
      }
      setLinkingShopMessageError('');
      setLinkingShopMessage(value);
      return 0;
    };
    const validEmail = () => {
      const value = email.trim();
      if (value === '') {
        setEmailError('必須項目です。');
        return 1;
      }
      setEmailError('');
      setEmail(value);
      return 0;
    };
    const validPassword = () => {
      const value = password.trim();
      if (value === '') {
        setPasswordError('必須項目です。');
        return 1;
      }
      if (
        value.length < 8 ||
        !/[A-Z]/.test(value) ||
        !/[a-z]/.test(value) ||
        !/[0-9]/.test(value)
      ) {
        setPasswordError(
          '英大文字・英小文字・数字全てを含め、8文字以上で入力してください。'
        );
        return 1;
      }
      setPasswordError('');
      setPassword(value);
      return 0;
    };
    const validConfirmPassword = () => {
      const value = password.trim();
      const valueConfirm = confirmPassword.trim();
      if (valueConfirm === '') {
        setConfirmPasswordError('必須項目です。');
        return 1;
      }
      if (value !== valueConfirm) {
        setConfirmPasswordError('パスワードが一致していません。');
        return 1;
      }
      setConfirmPasswordError('');
      setConfirmPassword(value);
      return 0;
    };
    const validEmailAuthCode = () => {
      const value = emailAuthCode.trim();
      if (value === '') {
        setEmailAuthCodeError('必須項目です。');
        return 1;
      }
      setEmailAuthCodeError('');
      setEmailAuthCode(value);
      return 0;
    };

    const validWebsite = () => {
      const value = website;
      const pattern = /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/;
      if (value && !pattern.test(value)) {
        setWebsiteError('URLを入力してください');
        return 1;
      }
      setWebsiteError('');
      setWebsite(value);
      return 0;
    };

    const valid = () => {
      let errorCount =
        validGroup() +
        validZipCodeSubmit() +
        validPrefectures() +
        validCityId() +
        validAddress() +
        validGroupContactName() +
        validDepartment() +
        validDirectPhone() +
        validPhone() +
        validFax() +
        validWebsite() +
        // validRegisterReason() +
        validLinkingShopMessage() +
        validBankName() +
        validBankBranchName() +
        validBankAccountNumber() +
        validBankAccountHolder();
      if (!emailAuthCodeChecked) {
        errorCount +=
          validEmail() +
          validPassword() +
          validConfirmPassword() +
          validEmailAuthCode();
      }
      if (errorCount === 0) {
        return true;
      }
      return false;
    };

    const convertImages = () => {
      const imageArray = {
        0: {
          image: image1,
          viewOrder: 0
        },
        1: {
          image: image2,
          viewOrder: 1
        },
        2: {
          image: image3,
          viewOrder: 2
        },
        3: {
          image: image4,
          viewOrder: 3
        },
        4: {
          image: image5,
          viewOrder: 4
        }
      };
      setImages(imageArray);
    };

    const convertGroupTypeStr = mode => {
      if (mode === 'CHAIN_SHOP') {
        setGroupTypeStr('チェーン店');
      } else if (mode === 'COMMERCIAL_COMPLEX') {
        setGroupTypeStr('商業施設');
      } else if (mode === 'CAMPAIGN') {
        setGroupTypeStr('キャンペーン');
      } else if (mode === 'GOCHI_KID') {
        setGroupTypeStr('こどもごちめし特別資金グループ');
      } else {
        setGroupTypeStr('その他/仮想店舗');
      }
    };
    const convertDepositManageStr = mode => {
      if (mode === 'NONSELF') {
        setDepositManageStr('銀行口座を登録する');
      } else if (mode === 'SELF') {
        setDepositManageStr('Stripeを登録する');
      } else {
        setDepositManageStr('グループでは入金管理を登録しない');
      }
    };
    const convertBankAccountTypeStr = mode => {
      if (mode === 'SAVINGS') {
        setBankAccountTypeStr('普通預金');
      } else {
        setBankAccountTypeStr('当座預金');
      }
    };

    const sendCodeAction = () => {
      if (validEmail() + validPassword() + validConfirmPassword() !== 0) {
        alert('メールアドレスとパスワードを正しく入力してください。');
      } else {
        updateLoading(true);
        updateOpenProgress(true);
        signUp(email, password)
          .then(() => {
            setResultMessage(
              '認証コードを送信しました。メールをご確認ください。'
            );
            updateLoading(false);
          })
          .catch(error => {
            if (error.code === 'UsernameExistsException') {
              setResultMessage('メールアドレスが存在しました。');
              updateLoading(false);
            }
          });
      }
    };
    const confirmAction = () => {
      if (!valid()) {
        alert('登録情報を正しく入力してください。');
      } else if (emailAuthCodeChecked) {
        convertImages();
        updateOpenGroupAddConfirm(true);
      } else {
        confirmSignUp(email, emailAuthCode)
          .then(() => {
            setCityNameData(cityId);
            convertImages();
            setEmailAuthCodeChecked(true);
            updateOpenGroupAddConfirm(true);
          })
          .catch(() => {
            alert('認証コードが正しくありません。');
          });
      }
    };

    const progressOkAction = () => {
      updateOpenProgress(false);
    };

    const backAction = () => updateOpenGroupAddConfirm(false);
    const getCitiesOptions = () => {
      const citiesOptions = [];
      const tmpObj = { label: '', value: '0' };
      if (!prefectureCode || prefectureCode === 0) {
        cities.forEach(item => {
          citiesOptions.push({
            label: item.cityName,
            value: String(item.cityId)
          });
        });
      } else {
        cities
          .filter(
            item =>
              item.prefCode && Number(item.prefCode) === Number(prefectureCode)
          )
          .forEach(item => {
            citiesOptions.push({
              label: item.cityName,
              value: String(item.cityId)
            });
          });
      }
      return { ...citiesOptions, tmpObj };
    };

    const groupDisplayLimit =
      groupType === 'CAMPAIGN' ||
      groupType === 'OTHERS' ||
      groupType === 'GOCHI_KID';

    return (
      <div className={classes.root}>
        <PublicHeader />
        <div className={classes.pageTitileDiv}>
          <Typography variant="h6" color="textSecondary">
            グループ運営会社登録申込書
          </Typography>
          <Typography color="textSecondary">
            グループ機能とは、複数店舗を束ねて、新規店舗登録、店舗情報変更、売上げ確認などが出来る機能です。
            <br />
            <span className={classes.caution}>
              4店舗以上の店舗をお持ちで無い方は登録できません
            </span>
            ので、前画面に戻り「新規加盟店登録はこちら」から登録ください。
            <br />
            申込み完了後、ごちめし事務局より、登録内容の確認・審査のご連絡をさしあげます。
            <br />
            <br />
            お申込みにあたっては、こちらの
            <Link
              href="https://gochimeshi.com/policy/owner-terms/"
              target="_blank"
              rel="noreferrer"
            >
              【ごちめし加盟店規約】
            </Link>
            をご参照、ご同意いただけますようお願いいたします。
            <br />
            さきめしは、ごちめしの機能を使ってコロナショックに苦しむ飲食店を応援するサービスです。
            <br />
            グループ運営会社マニュアルは
            <Link
              href="https://docs.google.com/document/d/1Ogk973Kx_uacU9PSDNUUKSLxcAZcCM-RgcAVCzxJJ3s/edit?usp=sharing"
              target="_blank"
              rel="noreferrer"
            >
              こちら
            </Link>
          </Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <Table className={classes.addTable}>
            <TableRow>
              <TableCell>
                <RequiredButton />
              </TableCell>
              <TableCell className={classes.tableCell90}>
                <TextField
                  required
                  label="貴グループ運営会社名"
                  placeholder="〇〇株式会社"
                  fullWidth
                  className={classes.textField}
                  margin="normal"
                  onChange={e => {
                    setGroupName(e.target.value);
                  }}
                  onBlur={validGroup}
                />
                <ValidationText message={errors.groupNameError} />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellBorderNone}>
                <RequiredButton />
              </TableCell>
              <TableCell className={classes.tableCellBorderNone}>
                <TextField
                  required
                  label="郵便番号"
                  className={classes.textField}
                  placeholder="0001111"
                  fullWidth
                  onChange={e => {
                    setZipCode(e.target.value);
                  }}
                  margin="normal"
                  onBlur={validZipCode}
                />
                <ValidationText message={errors.zipCodeError} />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellBorderNone} />
              <TableCell className={classes.tableCellBorderNone}>
                <TextField
                  required
                  select
                  label="都道府県"
                  fullWidth
                  className={classes.textField}
                  margin="normal"
                  value={prefectureCode}
                  onChange={e => {
                    setPrefectureCode(e.target.value);
                    setCityId(Number(0));
                  }}
                  InputLabelProps={{
                    shrink: true
                  }}
                  onBlur={validPrefectures}
                >
                  {prefectures.map(item => {
                    return (
                      <MenuItem key={item.id} value={item.id}>
                        {item.name}
                      </MenuItem>
                    );
                  })}
                </TextField>
                <ValidationText message={errors.prefecturesError} />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellBorderNone} />
              <TableCell className={classes.tableCellBorderNone}>
                {prefectureCode > 0 && (
                  <ReactSelectMaterialUi
                    required
                    fullWidth
                    label="市区町村*"
                    className={classes.textField}
                    defaultValue={String(cityId)}
                    value={String(cityId)}
                    options={getCitiesOptions()}
                    margin="normal"
                    onChange={z => {
                      setCityId(Number(z));
                    }}
                    SelectProps={{
                      isClearable: true,
                      msgNoOptionsMatchFilter:
                        '名前が部分一致する店舗がありません'
                    }}
                    onBlur={validCityId}
                  />
                )}
                {(!prefectureCode || prefectureCode <= 0) && (
                  <ReactSelectMaterialUi
                    disabled
                    required
                    fullWidth
                    label="市区町村*"
                    className={classes.textField}
                    defaultValue={String(cityId)}
                    value={String(cityId)}
                    options={getCitiesOptions()}
                    margin="normal"
                    onChange={z => {
                      setCityId(Number(z));
                    }}
                    SelectProps={{
                      isClearable: true,
                      msgNoOptionsMatchFilter:
                        '名前が部分一致する店舗がありません'
                    }}
                    onBlur={validCityId}
                  />
                )}
                <ValidationText message={errors.cityIdError} />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellBorderNone} />
              <TableCell className={classes.tableCellBorderNone}>
                <TextField
                  required
                  label="丁目・番地"
                  placeholder="1-2-3"
                  fullWidth
                  value={address}
                  className={classes.textField}
                  margin="normal"
                  onChange={e => {
                    setAddress(e.target.value);
                  }}
                  onBlur={validAddress}
                />
                <ValidationText message={errors.addressError} />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell />
              <TableCell>
                <TextField
                  label="建物名"
                  placeholder="○○ビル 102号"
                  fullWidth
                  className={classes.textField}
                  margin="normal"
                  onChange={e => {
                    setBuilding(e.target.value);
                  }}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <RequiredButton />
              </TableCell>
              <TableCell>
                <TextField
                  required
                  label="電話番号"
                  placeholder="09012345678"
                  fullWidth
                  className={classes.textField}
                  margin="normal"
                  onChange={e => {
                    setPhone(e.target.value);
                  }}
                  onBlur={validPhone}
                />
                <ValidationText message={errors.phoneError} />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <AnyButton />
              </TableCell>
              <TableCell>
                <TextField
                  label="FAX"
                  placeholder="09012345678"
                  fullWidth
                  className={classes.textField}
                  margin="normal"
                  onChange={e => {
                    setFax(e.target.value);
                  }}
                  onBlur={validFax}
                />
                <ValidationText message={errors.faxError} />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellBorderNone}>
                <RequiredButton />
              </TableCell>
              <TableCell className={classes.tableCellBorderNone}>
                店舗オーナーさまへの依頼）
                <br />
                店舗オーナーさまが登録された店舗の現場に連絡しても、
                「ごちめし」のことを全く知らないという事例が発生してきています。
                店舗登録時には現場の責任者に了解を取った後に登録ください。
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellBorderNone} />
              <TableCell className={classes.tableCellBorderNone}>
                <TextField
                  required
                  label="ご担当者名"
                  fullWidth
                  className={classes.textField}
                  margin="normal"
                  onChange={e => {
                    setGroupContactName(e.target.value);
                  }}
                  onBlur={validGroupContactName}
                />
                <ValidationText message={errors.groupContactNameError} />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellBorderNone} />
              <TableCell className={classes.tableCellBorderNone}>
                <TextField
                  required
                  label="所属部署"
                  fullWidth
                  className={classes.textField}
                  margin="normal"
                  onChange={e => {
                    setDepartment(e.target.value);
                  }}
                  onBlur={validDepartment}
                />
                <ValidationText message={errors.departmentError} />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell />
              <TableCell>
                <TextField
                  required
                  label="電話番号（直通等）"
                  fullWidth
                  className={classes.textField}
                  margin="normal"
                  onChange={e => {
                    setDirectPhone(e.target.value);
                  }}
                  onBlur={validDirectPhone}
                />
                <ValidationText message={errors.directPhoneError} />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <AnyButton />
              </TableCell>
              <TableCell>
                <FileUpload
                  label="image1"
                  setFile={setImage1}
                  previewImage={previewImage1}
                  setPreviewImage={setPreviewImage1}
                />
                <FileUpload
                  label="image2"
                  setFile={setImage2}
                  previewImage={previewImage2}
                  setPreviewImage={setPreviewImage2}
                />
                <FileUpload
                  label="image3"
                  setFile={setImage3}
                  previewImage={previewImage3}
                  setPreviewImage={setPreviewImage3}
                />
                <FileUpload
                  label="image4"
                  setFile={setImage4}
                  previewImage={previewImage4}
                  setPreviewImage={setPreviewImage4}
                />
                <FileUpload
                  label="image5"
                  setFile={setImage5}
                  previewImage={previewImage5}
                  setPreviewImage={setPreviewImage5}
                />
                <br />
                画像は５枚まで登録できます。複数枚登録した場合は、店舗詳細画面でスライド表示されます。店舗一覧には１番目に登録した画像が表示されます。
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <AnyButton />
              </TableCell>
              <TableCell>
                <TextField
                  label="グループの概要"
                  fullWidth
                  className={classes.textField}
                  margin="normal"
                  onChange={e => {
                    setDescription(e.target.value);
                  }}
                />
                <ValidationText message={errors.descriptionError} />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <AnyButton />
              </TableCell>
              <TableCell>
                <TextField
                  label="WebページURL"
                  placeholder="http://"
                  fullWidth
                  className={classes.textField}
                  margin="normal"
                  onChange={e => {
                    setWebsite(e.target.value);
                  }}
                  onBlur={validWebsite}
                />
                <ValidationText message={errors.websiteError} />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellBorderNone}>
                <RequiredButton />
              </TableCell>
              <TableCell className={classes.tableCellBorderNone}>
                <Typography className={classes.description}>
                  グループ種別
                </Typography>
                <RadioGroup
                  row
                  value={groupType}
                  onChange={e => {
                    setGroupType(e.target.value);
                    convertGroupTypeStr(e.target.value);
                  }}
                >
                  <FormControlLabel
                    value="CHAIN_SHOP"
                    control={<Radio color="primary" />}
                    label="チェーン店"
                  />
                  <FormControlLabel
                    value="COMMERCIAL_COMPLEX"
                    control={<Radio color="primary" />}
                    label="商業施設"
                  />
                  <FormControlLabel
                    value="CAMPAIGN"
                    control={<Radio color="primary" />}
                    label="キャンペーン"
                  />
                  <FormControlLabel
                    value="OTHERS"
                    disabled
                    control={<Radio color="primary" />}
                    label="その他/仮想店舗"
                  />
                  <FormControlLabel
                    value="GOCHI_KID"
                    control={<Radio color="primary" />}
                    label="こどもごちめし特別資金グループ"
                  />
                </RadioGroup>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell />
              <TableCell>
                [チェーン店]
                <br />
                同一（あるいは複数）ブランドの直営・フランチャイズ展開を実施している場合に選択ください。
                <br />
                <br />
                [商業施設]
                <br />
                経営会社が異なる複数ブランドを束ねた施設を運営している場合に選択ください。
                <br />
                <br />
                [キャンペーン]
                <br />
                自治体案件や、期間限定キャンペーンなどに該当する場合に選択してください。
                <br />
                <br />
                <span className={classes.greyText}>[その他/仮想店舗]</span>
                <br />
                <span className={classes.greyText}>
                  子ども食堂、災害時支援など、上記と異なる用途の場合に選択ください。
                </span>
                <br />
                <br />
                [こどもごちめし特別資金グループ]
                <br />
                こどもごちめし特別資金グループに該当する場合に選択してください。
              </TableCell>
            </TableRow>
            {!groupDisplayLimit && (
              <TableRow>
                <TableCell
                  className={
                    depositManage === 'NONSELF'
                      ? classes.tableCellBorderNone
                      : ''
                  }
                >
                  <RequiredButton />
                </TableCell>
                <TableCell
                  className={
                    depositManage === 'NONSELF'
                      ? classes.tableCellBorderNone
                      : ''
                  }
                >
                  <Typography className={classes.description}>
                    入金管理
                  </Typography>
                  <RadioGroup
                    value={depositManage}
                    onChange={e => {
                      setDepositManage(e.target.value);
                      convertDepositManageStr(e.target.value);
                    }}
                  >
                    <div>
                      <FormControlLabel
                        value="NOT_MANAGE"
                        control={<Radio color="primary" />}
                        label="グループでは入金管理を登録しない"
                      />
                      <Typography className={classes.discription}>
                        グループの各店舗別に、入金する銀行口座を登録して頂きます。
                      </Typography>
                    </div>
                    <div className={classes.depositManageDiv}>
                      <FormControlLabel
                        value="NONSELF"
                        control={<Radio color="primary" />}
                        label="銀行口座を登録する"
                      />
                      <Typography className={classes.discription}>
                        グループの全店舗の入金が同一の口座に振り込まれます。
                        <br />
                        また各店舗の登録情報に口座情報は掲載されません。
                      </Typography>
                    </div>
                    <div>
                      <FormControlLabel
                        value="SELF"
                        control={<Radio color="primary" />}
                        label="Stripeを登録する"
                      />
                    </div>
                  </RadioGroup>
                </TableCell>
              </TableRow>
            )}
            {groupType !== 'OTHERS' && !groupDisplayLimit && (
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <RequiredButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <Typography className={classes.description}>
                    社食ごちめし現金授受の有無
                  </Typography>
                  <RadioGroup
                    row
                    value={cashAllowed}
                    onChange={e => {
                      const allowed = parseInt(e.target.value, 10);
                      setCashAllowed(allowed);
                    }}
                  >
                    <FormControlLabel
                      value={0}
                      control={<Radio color="primary" />}
                      label="受け付けない"
                    />
                    <FormControlLabel
                      value={1}
                      control={<Radio color="primary" />}
                      label="受け付ける"
                    />
                  </RadioGroup>
                </TableCell>
              </TableRow>
            )}
            {groupType !== 'OTHERS' && !groupDisplayLimit && (
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <RequiredButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <Typography className={classes.description}>
                    社食ごちめし金額指定チケット利用の有無
                  </Typography>
                  <RadioGroup
                    row
                    value={allowMenuPriceShashoku}
                    onChange={e => {
                      setAllowMenuPriceShashoku(parseInt(e.target.value, 10));
                    }}
                  >
                    <FormControlLabel
                      value={1}
                      control={<Radio color="primary" />}
                      label="利用する"
                    />
                    <FormControlLabel
                      value={0}
                      control={<Radio color="primary" />}
                      label="利用しない"
                    />
                  </RadioGroup>
                </TableCell>
              </TableRow>
            )}
            {depositManage === 'NONSELF' && !groupDisplayLimit && (
              <TableRow>
                <TableCell className={classes.tableCellBorderNone} />
                <TableCell className={classes.tableCellBorderNone}>
                  <TextField
                    required
                    label="銀行名"
                    placeholder="○○銀行"
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setBankName(e.target.value);
                    }}
                    onBlur={validBankName}
                  />
                  <ValidationText message={errors.bankNameError} />
                </TableCell>
              </TableRow>
            )}
            {depositManage === 'NONSELF' && !groupDisplayLimit && (
              <TableRow>
                <TableCell className={classes.tableCellBorderNone} />
                <TableCell className={classes.tableCellBorderNone}>
                  <TextField
                    required
                    label="支店名"
                    placeholder="○○支店"
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setBankBranchName(e.target.value);
                    }}
                    onBlur={validBankBranchName}
                  />
                  <ValidationText message={errors.bankBranchNameError} />
                </TableCell>
              </TableRow>
            )}
            {depositManage === 'NONSELF' && !groupDisplayLimit && (
              <TableRow>
                <TableCell className={classes.tableCellBorderNone} />
                <TableCell className={classes.tableCellBorderNone}>
                  <Typography className={classes.description}>
                    口座種別
                  </Typography>
                  <RadioGroup
                    row
                    value={bankAccountType}
                    onChange={e => {
                      setBankAccountType(e.target.value);
                      convertBankAccountTypeStr(e.target.value);
                    }}
                  >
                    <FormControlLabel
                      value="SAVINGS"
                      control={<Radio color="primary" />}
                      label="普通預金"
                    />
                    <FormControlLabel
                      value="CHECKING"
                      control={<Radio color="primary" />}
                      label="当座預金"
                    />
                  </RadioGroup>
                </TableCell>
              </TableRow>
            )}
            {depositManage === 'NONSELF' && !groupDisplayLimit && (
              <TableRow>
                <TableCell className={classes.tableCellBorderNone} />
                <TableCell className={classes.tableCellBorderNone}>
                  <TextField
                    required
                    label="口座番号"
                    placeholder="1234567"
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setBankAccountNumber(e.target.value);
                    }}
                    onBlur={validBankAccountNumber}
                  />
                  <ValidationText message={errors.bankAccountNumberError} />
                </TableCell>
              </TableRow>
            )}
            {depositManage === 'NONSELF' && !groupDisplayLimit && (
              <TableRow>
                <TableCell className={classes.tableCellBorderNone} />
                <TableCell className={classes.tableCellBorderNone}>
                  半角数字・7桁（6桁以下の方は先頭に0をつけて7桁にしてください）
                </TableCell>
              </TableRow>
            )}
            {depositManage === 'NONSELF' && !groupDisplayLimit && (
              <TableRow>
                <TableCell className={classes.tableCellBorderNone} />
                <TableCell className={classes.tableCellBorderNone}>
                  <TextField
                    required
                    label="口座名義"
                    placeholder="ヤマダ　タロウ"
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setBankAccountHolder(e.target.value);
                    }}
                    onBlur={validBankAccountHolder}
                  />
                  <ValidationText message={errors.bankAccountHolderError} />
                </TableCell>
              </TableRow>
            )}
            {depositManage === 'NONSELF' && !groupDisplayLimit && (
              <TableRow>
                <TableCell />
                <TableCell>必ず漢字/ひらがな以外でご記入ください。</TableCell>
              </TableRow>
            )}
            {/* <TableRow>
              <TableCell className={classes.tableCellBorderNone}>
                <RequiredButton />
              </TableCell>
              <TableCell className={classes.tableCellBorderNone}>
                <TextField
                  required
                  multiline
                  rows="4"
                  label="グループ登録の概要"
                  className={classes.textField}
                  placeholder="登録数：10店舗&#13;&#10;URL：https://gochimeshi.com/"
                  fullWidth
                  onChange={e => {
                    setRegisterReason(e.target.value);
                  }}
                  margin="normal"
                  onBlur={validRegisterReason}
                />
                <ValidationText message={errors.registerReasonError} />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellBorderNone} />
              <TableCell className={classes.tableCellBorderNone}>
                グループ店舗として登録したい数(4店舗以上が必要です）、参考となる御社Webサイト（URL）
                などを記載してください。
                <br />
                弊社からの連絡・審査に利用させていただきます。
              </TableCell>
            </TableRow> */}
            <TableRow>
              <TableCell className={classes.tableCellBorderNone}>
                <AnyButton />
              </TableCell>
              <TableCell className={classes.tableCellBorderNone}>
                <TextField
                  // required
                  multiline
                  rows="3"
                  label="グループ紐付け時のメッセージ"
                  className={classes.textField}
                  fullWidth
                  onChange={e => {
                    setLinkingShopMessage(e.target.value);
                  }}
                  inputProps={{
                    maxLength: 1000
                  }}
                  margin="normal"
                  onBlur={validLinkingShopMessage}
                />
                <ValidationText message={errors.linkingShopMessageError} />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellBorderNone} />
              <TableCell className={classes.tableCellBorderNone}>
                店舗をグループに紐づける時にメールが送信されます。対象店舗にグループ紐付け時にお伝えしたいメッセージを記載することができます。
              </TableCell>
            </TableRow>
          </Table>

          <Divider className={classes.divider} />
          <div className={classes.subTitle}>
            <Typography variant="h6">メールアドレス確認</Typography>
            <Typography className={classes.description}>
              メールアドレスとパスワードを入力して、
              メールアドレス宛に届いた認証コードを入力してください。
            </Typography>
          </div>
          <Table className={classes.editTable}>
            <TableRow>
              <TableCell className={classes.tableCellBorderNone}>
                <RequiredButton />
              </TableCell>
              <TableCell
                className={classNames(
                  classes.tableCellBorderNone,
                  classes.tableCell90
                )}
              >
                <TextField
                  required
                  label="メールアドレス"
                  placeholder="gochimeshi@gochi.com"
                  type="email"
                  fullWidth
                  className={classes.textField}
                  margin="normal"
                  InputProps={{
                    readOnly: emailAuthCodeChecked
                  }}
                  onChange={e => {
                    setEmail(e.target.value);
                  }}
                  onBlur={validEmail}
                />
                <br />
                <Typography variant="h7">
                  他の店舗で使用したメールアドレスは使用できません。
                  <br />
                  一つの店舗に一つのメールアドレスを割り当ててください。
                </Typography>
                <ValidationText message={errors.emailError} />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellBorderNone}>
                <RequiredButton />
              </TableCell>
              <TableCell className={classes.tableCellBorderNone}>
                <TextField
                  required
                  label="パスワード"
                  type="password"
                  fullWidth
                  className={classes.textField}
                  margin="normal"
                  InputProps={{
                    readOnly: emailAuthCodeChecked
                  }}
                  onChange={e => {
                    setPassword(e.target.value);
                  }}
                  onBlur={validPassword}
                />
                <ValidationText message={errors.passwordError} />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellBorderNone} />
              <TableCell className={classes.tableCellBorderNone}>
                英大文字・英小文字・数字全てを含め、8文字以上
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellBorderNone}>
                <RequiredButton />
              </TableCell>
              <TableCell className={classes.tableCellBorderNone}>
                <TextField
                  required
                  label="確認用パスワード"
                  type="password"
                  fullWidth
                  className={classes.textField}
                  margin="normal"
                  InputProps={{
                    readOnly: emailAuthCodeChecked
                  }}
                  onChange={e => {
                    setConfirmPassword(e.target.value);
                  }}
                  onBlur={validConfirmPassword}
                />
                <ValidationText message={errors.confirmPasswordError} />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellBorderNone} />
              <TableCell className={classes.tableCellBorderNone}>
                <SendCodeButton
                  onClickAction={sendCodeAction}
                  enabled={!emailAuthCodeChecked}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellBorderNone}>
                <RequiredButton />
                {emailAuthCodeChecked && <CheckOkButton />}
              </TableCell>
              <TableCell className={classes.tableCellBorderNone}>
                <TextField
                  required
                  label="認証コード"
                  fullWidth
                  className={classes.textField}
                  margin="normal"
                  InputProps={{
                    readOnly: emailAuthCodeChecked
                  }}
                  onChange={e => {
                    setEmailAuthCode(e.target.value);
                  }}
                  onBlur={validEmailAuthCode}
                />
                <ValidationText message={errors.emailAuthCodeError} />
              </TableCell>
            </TableRow>
          </Table>
          <Divider className={classes.divider} />
          <Table className={classes.editTable}>
            <TableRow>
              <TableCell className={classes.tableCellBorderNone}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={consent}
                      onChange={e => {
                        setConsent(e.target.checked);
                      }}
                      color="primary"
                    />
                  }
                  label="ごちめし加盟店規約に同意する"
                />
              </TableCell>
              <TableCell className={classes.tableCellBorderNone} />
              <TableCell className={classes.tableCellBorderNone} />
            </TableRow>
          </Table>
          <div>
            <ConfirmButton onClickAction={confirmAction} consent={consent} />
          </div>
        </Paper>
        <div>
          <Button
            color="primary"
            onClick={() => {
              handleRedirect('/');
            }}
          >
            ログイン画面はこちら
          </Button>
        </div>
        <Modal open={openGroupAddConfirm}>
          <GroupAddConfirm
            updateOpenGroupAdd={updateOpenGroupAdd}
            updateOpenGroupAddConfirm={updateOpenGroupAddConfirm}
            backAction={backAction}
            registerAction={registerAction}
            addConfirm={addConfirm}
            addParam={addParam}
            email={email}
            password={password}
            prefectures={prefectures}
            setCognitoUserId={setCognitoUserId}
          />
        </Modal>
        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
        <PublicFooter />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
